export enum BotType {
  DaliySalesReport = "daily_sales_report",
  DiningRommSales = "dining_room_sales",
  TacoBell = "taco_bell",
  ActiveCrewStaff = "active_crew_staff",
  PredictiveScheduling = "predictive_scheduling",
  TacoBellDelaget = "taco_bell_delaget",
}